// Per-route SEO for the SPA — sets title, meta description, canonical URL, and
// robots directive on navigation.
//
// These are also what the build-time prerender captures: scripts/prerender.js
// loads each route in a headless browser and writes out the resulting DOM, so
// whatever this sets becomes the static HTML a crawler sees without running JS.
// Before prerendering existed, every URL served the index.html default —
// canonical pointing at the homepage — and Google filed the whole site as
// duplicates of "/".

export function setPageSeo({ title, description, canonical, robots }) {
  if (title) document.title = title;
  if (description !== undefined) {
    let m = document.querySelector('meta[name="description"]');
    if (!m) {
      m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
    }
    m.setAttribute('content', description);
  }
  if (canonical !== undefined) {
    let l = document.querySelector('link[rel="canonical"]');
    if (!l) {
      l = document.createElement('link');
      l.setAttribute('rel', 'canonical');
      document.head.appendChild(l);
    }
    l.setAttribute('href', canonical);
  }
  // Always set explicitly rather than only on noindex: this is a SPA, so a
  // noindex left over from a previous route would otherwise follow the user
  // (and the prerenderer) onto a page that should be indexed.
  if (robots !== undefined) {
    let m = document.querySelector('meta[name="robots"]');
    if (!m) {
      m = document.createElement('meta');
      m.setAttribute('name', 'robots');
      document.head.appendChild(m);
    }
    m.setAttribute('content', robots);
  }
}
